import { render, staticRenderFns } from "./giftApplyDetail.vue?vue&type=template&id=7356060c&scoped=true&"
import script from "./giftApplyDetail.vue?vue&type=script&lang=js&"
export * from "./giftApplyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7356060c",
  null
  
)

export default component.exports